module.exports = __webpack_public_path__ + "img/hold.082ba444.png";